module.exports = __webpack_public_path__ + "static/media/produkt @1x.1ae0ec04.jpg";